import styled, { css } from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import Icon from 'components/priority/Icon/Icon'
import colors from 'utils/styling/colors'

export const CategoryItem = styled(Flex)`
  &:hover {
    background: ${colors('gray5')};
  }
`

export const ItemArrow = styled(Icon)(
  ({ selected }) => css`
    transform: rotate(${selected ? '-180deg' : '0deg'});
    transition: 0.25s;
  `,
)
